import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
const FiveStars = () => <div className="flex gap-0.5 mb-4" data-id="element-237">
    {[...Array(5)].map((_, i) => <Star key={i} className="text-brand-gold fill-current" size={18} data-id="element-238" />)}
  </div>;
const fullTestimonials = [{
  initials: 'MP',
  name: 'María P.',
  city: 'Milano',
  quote: "L'ho comprato di sabato. Domenica sera avevo il mese di sessioni pronto. Non improvviso mai più."
}, {
  initials: 'CG',
  name: 'Claudia G.',
  city: 'Roma',
  quote: 'Tre allievi intermedi che erano bloccati sono progrediti nel primo mese con il Tomo 2. I miei allievi mi chiedono cosa ho cambiato.'
}, {
  initials: 'FR',
  name: 'Federico R.',
  city: 'Napoli',
  quote: 'Prima impiegavo 1 ora per preparare una sessione. Ora ci metto 5 minuti. Quel tempo ora lo uso per trovare nuovi allievi.'
}, {
  initials: 'SV',
  name: 'Sofía V.',
  city: 'Torino',
  quote: 'Il Bonus di Anatomia ha cambiato come correggo i miei allievi nel Reformer. Ora so esattamente quale muscolo lavorare e quale cue dare. I miei allievi lo notano.'
}, {
  initials: 'DA',
  name: 'Diego A.',
  city: 'Bologna',
  quote: "La Checklist di Sicurezza mi ha salvato con un'allieva con ernia lombare. Sapevo esattamente cosa fare in ogni sessione senza improvvisare con la sua salute."
}, {
  initials: 'CR',
  name: 'Carolina R.',
  city: 'Firenze',
  quote: "Il Calendario delle 1.000 Sessioni ha cambiato il mio rapporto con l'insegnamento. Arrivo in studio sapendo esattamente cosa insegnerò. Senza ansia. Senza sensi di colpa."
}];
export const Social = () => {
  return <section className="py-20 bg-brand-cream" data-id="element-239">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-240">
        {/* Testimonials Grid */}
        <div className="text-center mb-16" data-id="element-241">
          <h2 className="text-4xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-242">
            Cosa dicono gli insegnanti
          </h2>
          <div className="flex items-center justify-center gap-2 text-2xl font-bold text-brand-charcoal" data-id="element-243">
            4.9/5 <Star className="text-brand-gold fill-current" size={28} data-id="element-244" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24" data-id="element-245">
          {fullTestimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-sand" data-id="element-246">
              <FiveStars data-id="element-247" />
              <div className="flex items-center gap-4 mb-6" data-id="element-248">
                <div className="w-12 h-12 bg-brand-charcoal text-white rounded-full flex items-center justify-center font-serif font-bold text-xl" data-id="element-249">
                  {t.initials}
                </div>
                <div data-id="element-250">
                  <div className="font-bold text-brand-charcoal" data-id="element-251">{t.name}</div>
                  <div className="text-sm text-gray-500" data-id="element-252">{t.city}</div>
                </div>
              </div>
              <p className="text-gray-700 italic leading-relaxed" data-id="element-253">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>

        {/* Guarantee */}
        <div className="max-w-3xl mx-auto bg-white rounded-3xl p-10 md:p-16 text-center shadow-xl border border-brand-sand" data-id="element-254">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 text-green-600 rounded-full mb-8" data-id="element-255">
            <ShieldCheck size={40} data-id="element-256" />
          </div>
          <h3 className="text-3xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-257">
            🛡️ Garanzia 7 giorni senza domande
          </h3>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-258">
            Apri i 12 Tomi. Controlla i 6 Bonus. Usa gli Ebooks Élite nella tua
            lezione. <br data-id="element-259" />
            <br data-id="element-260" />
            Se non è quello che ti aspettavi → rimborso del 100%. Senza domande.
            Senza moduli. Senza drammi.
          </p>
          <div className="inline-block bg-brand-sand/30 px-6 py-3 rounded-full font-bold text-brand-charcoal tracking-wide" data-id="element-261">
            TASSO DI RESO INFERIORE AL 2%
          </div>
        </div>
      </div>
    </section>;
};